import { useRef as L, useState as r, useEffect as i } from "react";
import { O as S } from "../../../main-DWhYBTRK.js";
function x(u) {
  const t = L(null), [o, d] = r(0), [f, h] = r(0), [a, v] = r(1), m = o > 0, W = o + a < f, n = () => {
    t.current && (h(t.current.scrollWidth), v(t.current.clientWidth));
  };
  i(n, [u]), i(() => {
    const e = t.current, s = S(n, 500), l = () => {
      var c;
      return d(((c = t.current) == null ? void 0 : c.scrollLeft) ?? 0);
    };
    return e == null || e.addEventListener("scroll", l), window.addEventListener("resize", s), () => {
      e == null || e.removeEventListener("scroll", l), window.removeEventListener("resize", s);
    };
  }, []);
  function p() {
    t.current && t.current.scrollBy({
      top: 0,
      left: -t.current.offsetWidth,
      behavior: "smooth"
    });
  }
  function E() {
    t.current && t.current.scrollBy({
      top: 0,
      left: t.current.offsetWidth,
      behavior: "smooth"
    });
  }
  return {
    carouselRef: t,
    shouldDisplayPrev: m,
    shouldDisplayNext: W,
    scrollPrev: p,
    scrollNext: E
  };
}
export {
  x as useCarousel
};
